import React from 'react';
import MediaQuery from 'react-responsive'
import './Home3.scss'

const HomeDesktop = ({sectionCurrently, positionCurrently, Section, Position, responsive}) => {
    
    const subtitleFirst = "Get all the insurance and benefits";
    const subtitleSecond = "of a Visa premium card";

    return (
        <>
            <MediaQuery minWidth={1050}>
                <div className="third-body-section disposition-row justify-center align-center" id = "section-3">
                    <div className="third-body-elements disposition-column justify-start align-center">
                        <div className="first-row disposition-row justify-start align-start">
                            <div className = "description-section fade-slide-in-animation disposition-column justify-start align-start ">
                                <p className = "title-1">Karta<br/><b>Visa Infinite</b></p>
                                <p className = "text-1">{subtitleFirst}<br/>{subtitleSecond}</p>
                            </div>
                            <div className = "icons-elements disposition-row justify-between align-center">
                                <div className = "icon-element disposition-row justify-between align-start">
                                    <img src = "assets/Home/Home3/icon1.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Price protection of $4,000</p>
                                </div>
                                <div className = "icon-element disposition-row justify-between align-start">
                                    <img src = "assets/Home/Home3/icon4.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">$600 for Baggage Delay / $3,000 for Baggage Loss Insurance</p>
                                </div>
                                <div className = "icon-element disposition-row justify-between align-start">
                                    <img src = "assets/Home/Home3/icon2.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Purchase protection of $20,000</p>
                                </div>
                                <div className = "icon-element disposition-row justify-between align-start">
                                    <img src = "assets/Home/Home3/icon5.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Visa Luxury Hotel Collection</p>
                                </div>
                                <div className = "icon-element disposition-row justify-between align-start">
                                    <img src = "assets/Home/Home3/icon3.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Global Auto Rental Insurance</p>
                                </div>
                            </div>
                        </div>
                        {/* <img src = "assets/Home/Home3/banner.png" className = "banner-img" alt = "Banner"></img>
                        <img src = "assets/Home/Home3/money.png" className = "money-img" alt = "1$" id = "section-7"></img>
                        <p className = "title-2"><b>Use it anywhere in the world,</b> no international transaction fees.</p> */}
                    </div>
                </div>
            </MediaQuery>
            <MediaQuery maxWidth={1049.99} minWidth={650}>
                <div className="third-body-section-t disposition-row justify-center align-center" id = "section-3">
                    <div className="third-body-elements disposition-column justify-start align-center">
                        <div className="first-row disposition-column justify-start align-center">
                            <div className = "description-section fade-slide-in-animation disposition-column justify-start align-center">
                                <p className = "title-1">Karta<br/><b>Visa Infinite</b></p>
                                <p className = "text-1">{subtitleFirst}<br/>{subtitleSecond}</p>
                            </div>
                            <div className = "icons-elements disposition-row justify-between align-center">
                                <div className = "icon-element disposition-row justify-between align-center">
                                    <img src = "assets/Home/Home3/icon1.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Price protection of $4,000</p>
                                </div>
                                <div className = "icon-element disposition-row justify-between align-center">
                                    <img src = "assets/Home/Home3/icon4.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">$600 for Baggage Delay / $3,000 for Baggage Loss Insurance</p>
                                </div>
                                <div className = "icon-element disposition-row justify-between align-center">
                                    <img src = "assets/Home/Home3/icon2.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Purchase protection of $20,000</p>
                                </div>
                                <div className = "icon-element disposition-row justify-between align-center">
                                    <img src = "assets/Home/Home3/icon5.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Visa Luxury Hotel Collection</p>
                                </div>
                                <div className = "icon-element disposition-row justify-between align-center">
                                    <img src = "assets/Home/Home3/icon3.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Global Auto Rental Insurance</p>
                                </div>
                            </div>
                        </div>
                        {/* <img src = "assets/Home/Home3/banner.png" className = "banner-img" alt = "Banner"></img>
                        <img src = "assets/Home/Home3/money.png" className = "money-img" alt = "1$"></img>
                        <p className = "title-2"><b>Use it anywhere in the world,</b> no international transaction fees.</p> */}
                    </div>
                </div>
            </MediaQuery>
            <MediaQuery maxWidth = {649.99}>
                <div className="third-body-section-t disposition-row justify-center align-center" id = "section-3">
                    <div className="third-body-elements disposition-column justify-start align-center">
                        <div className="first-row disposition-column justify-start align-center">
                            <img src = "assets/Home/Home3/img-boat.png" className = "img-boat" alt = "Boat"></img>
                            <div className = "description-section fade-slide-in-animation disposition-column justify-start align-center">
                                <p className = "title-1">Karta<br/><b>Visa Infinite</b></p>
                                <p className = "text-1">{subtitleFirst}<br/>{subtitleSecond}</p>
                            </div>
                            <div className = "icons-elements disposition-row justify-center align-center">
                                <div className = "icon-element disposition-row justify-start align-center">
                                    <img src = "assets/Home/Home3/icon1.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Price protection of $4,000</p>
                                </div>
                                <div className = "icon-element disposition-row justify-start align-center">
                                    <img src = "assets/Home/Home3/icon2.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Purchase protection of $20,000</p>
                                </div>
                                <div className = "icon-element disposition-row justify-start align-center">
                                    <img src = "assets/Home/Home3/icon3.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Global Auto Rental Insurance</p>
                                </div>
                                <div className = "icon-element disposition-row justify-start align-start">
                                    <img src = "assets/Home/Home3/icon4.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">$600 for Baggage Delay / $3,000 for Baggage Loss Insurance</p>
                                </div>
                                <div className = "icon-element disposition-row justify-start align-center">
                                    <img src = "assets/Home/Home3/icon5.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Visa Luxury Hotel Collection</p>
                                </div>
                                
                            </div>
                        </div>
                        {/* <img src = "assets/Home/Home3/karta-top.png" className = "banner-img" alt = "Banner" ></img>
                        <div style={{height: "60px", width: "1px"}} id = "section-7"></div>
                        <p className = "title-2" ><b>Use it anywhere in the world,</b> no international transaction fees.</p>
                        <img src = "assets/Home/Home3/money.png" className = "money-img" alt = "1$"></img> */}
                    </div>
                </div>
            </MediaQuery>
        </>
    );
};

export default HomeDesktop;
